module.exports = __webpack_public_path__ + "static/media/checkitoff-macbook-status.599eb332.jpg";